class CartNotification extends HTMLElement {
  constructor() {
    super()

    this.notification = this
    this.notificationId = this.id
    this.handleOutsideEvent = this.handleOutsideEvent.bind(this)
    this.closeTimeoutId = null
    this.productsAdded = null
    this.onKeyUp = this.onKeyUp.bind(this)
    this.close = this.close.bind(this)
    this.toggleCart = this.toggleCart.bind(this)
    this.onProductAddError = this.onProductAddError.bind(this)
    this.onMouseOver = this.onMouseOver.bind(this)
    this.onMouseOut = this.onMouseOut.bind(this)
  }

  connectedCallback() {
    this.notification.addEventListener('keyup', this.onKeyUp)
    this.querySelector('.js-close-notification')?.addEventListener(
      'click',
      this.close
    )
    this.querySelector('[id^="js-cart-toggle"]')?.addEventListener(
      'click',
      this.toggleCart
    )

    document.addEventListener('productAddFailed', this.onProductAddError)

    this.addEventListener('mouseover', this.onMouseOver)
    this.addEventListener('mouseout', this.onMouseOut)
  }

  disconnectedCallback() {
    this.notification.removeEventListener('keyup', this.onKeyUp)
    this.querySelector('.js-close-notification')?.removeEventListener(
      'click',
      this.close
    )
    this.querySelector('[id^="js-cart-toggle"]')?.removeEventListener(
      'click',
      this.toggleCart
    )

    document.removeEventListener('productAddFailed', this.onProductAddError)

    this.removeEventListener('mouseover', this.onMouseOver)
    this.removeEventListener('mouseout', this.onMouseOut)
  }

  onMouseOver() {
    clearTimeout(this.closeTimeoutId)
  }

  onMouseOut() {
    this.closeTimeoutId = setTimeout(() => this.close(), 3000)
  }

  onProductAddError(e) {
    if (
      `cart-notification-product-error-${e.detail.productId}` === this.notificationId
    ) {
      this.open()
    }
  }

  onKeyUp(evt) {
    if (evt.code === 'Escape') this.close()
  }

  toggleCart(e) {
    this.dispatchEvent(
      new CustomEvent('toggleCart', {
        bubbles: true,
        composed: true,
        detail: {
          key: 'notification',
          event: e,
        },
      })
    )
  }

  open() {
    this.notification.classList.remove('hidden')
    this.notification.setAttribute('aria-hidden', false)
    setTimeout(
      () =>
        this.notification.classList.remove(
          'cart-notification__wrapper--hidden'
        ),
      0
    )
    document.addEventListener('focusin', this.handleOutsideEvent)
    this.notification.focus()

    this.closeTimeoutId = setTimeout(() => this.close(), 3000)
  }

  handleOutsideEvent(e) {
    requestAnimationFrame(() => {
      // Check if the new focused element is a child of the original container

      if (!this.contains(e.target)) {
        this.close()
      }
    })
  }

  close() {
    this.notification.classList.add('cart-notification__wrapper--hidden')
    setTimeout(() => this.notification.classList.add('hidden'), 50)
    document.removeEventListener('focusin', this.handleOutsideEvent)
  }
}

customElements.define('hh-cart-notification', CartNotification)
